module.exports = __webpack_public_path__ + "img/36.af46ebf0.jpg";